export default __webpack_public_path__ + "static/media/p1.f4a286b7.jpg";